import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { loadStoredSession } from "./storage";
import type { AuthState, User } from "./types";

interface LoginPayload {
    user: User;
}

const initialState: AuthState = loadStoredSession();

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginSuccess: (state, action: PayloadAction<LoginPayload>) => {
            state.user = action.payload.user;
            state.isAuthenticated = true;
            state.isReady = true;
        },
        resolveSession: (state, action: PayloadAction<User | null>) => {
            state.user = action.payload;
            state.isAuthenticated = Boolean(action.payload);
            state.isReady = true;
        },
        logout: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.isReady = true;
        },
    },
});

export const { loginSuccess, logout, resolveSession } = authSlice.actions;
export default authSlice.reducer;
